export type SignalSubscriber<T extends any> = (data: T) => void;
export type SignalDispatch<T extends any> = (data: T) => void;
export type SignalUnsubscribe = () => void;

const createEventSignal = <T extends any = void>(): [
  (subscriber: SignalSubscriber<T>) => SignalUnsubscribe,
  SignalDispatch<T>
] => {
  const subscribers: SignalSubscriber<T>[] = [];

  const subscribe = (subscriber: SignalSubscriber<T>): SignalUnsubscribe => {
    let isSubscribed = true;
    subscribers.push(subscriber);

    const unsubscribe = () => {
      if (isSubscribed) {
        isSubscribed = false;
        const index = subscribers.indexOf(subscriber);
        subscribers.splice(index, 1);
      }
    }

    return unsubscribe;
  };

  const dispatch = <Data extends T>(data: Data) => {
    subscribers.forEach((subscriber) => subscriber(data));
  };

  return [
    subscribe,
    dispatch
  ];
};

export default createEventSignal;
